import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'ui-file-upload',
  styleUrls: ['./ui-styles.css'],
  template: `
     <div *ngIf="currentQuestion?.dataTypeName === 'extuploadinput'" class="file-upload">
      <label>Upload Return to Work Documentation</label>
      <input
        type="file"
        (change)="onSelectFile($event)"
        accept=".jpg, .gif, .png, .apng, .svg, .bmp, .ico, .pdf"
      />
            <small>
        <i>File types accepted: jpeg, gif, png, apng, svg, bmp, bmp ico, png ico, and PDF</i>
      </small>
      <br>
      <img [src]="uploadUrl" height="200" *ngIf="uploadUrl" style="margin-top: 10px;" />
    </div>
  `,
  styles: [`
    /* Add any additional styles here */
  `]
})
export class UploadComponent {
  @Input() currentQuestion: any;
  @Output() fileSelected = new EventEmitter<string>();  // Emit base64 string of the file
  uploadUrl: string | undefined;
    constructor(private toastr: ToastrService) { }
  onSelectFile(event: Event): void {
    
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];
     
      // Allowed file types
      const allowedTypes = [
        'image/jpeg',
        'image/gif',
        'image/png',
        'image/apng',
        'image/svg+xml',
        'image/bmp',
        'image/x-icon',
        'application/pdf'
      ];
      if (!allowedTypes.includes(file.type)) {
        this.toastr.error('File type not allowed. Please select an image or PDF.', 'Invalid File Type');
        input.value = '';
        this.uploadUrl = '';
        if (this.currentQuestion) {
          this.currentQuestion.answerText = '';
        }

        return; 
      }

      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.uploadUrl = e.target.result;
        this.currentQuestion.answerText = file.name;
        this.fileSelected.emit(e.target.result);  // Emit the base64 string
      };

      reader.readAsDataURL(file);
    }
  }
}


//template: `
//     <div *ngIf="currentQuestion?.dataTypeName === 'extuploadinput'" class="file-upload">
//      <label>Upload Return to Work Documentation</label>
//      <input
//        type="file"
//        (change)="onSelectFile($event)"
//        accept=".jpg, .gif, .png, .apng, .svg, .bmp, .ico, .pdf"
//      />
//      <small>
//        <i>File types accepted: jpeg, gif, png, apng, svg, bmp, bmp ico, png ico, and PDF</i>
//      </small>
//      <img [src]="uploadUrl" height="200" *ngIf="uploadUrl" style="margin-top: 10px;" />
//    </div>
//  `,
